<div class="addRequestModal">
  <p-dialog [(visible)]="displayComponent"
            [header]="'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.MODAL_TITLE' | translate"
            [draggable]="false"
            [closable]="true"
            [resizable]="false"
            [modal]="true" [closeOnEscape]="false"
            (onHide)="displayComponentChange.emit(false);newRequestName=''">

    <!--New request-->
    <div *ngIf="isABrandNewRequest()" class="grid">

      <!--Describtion-->
      <div class="col-12">
        <h3 class="center">{{'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.NEW_REQUEST_DESCRIBTION_MESSAGE' |
          translate}}</h3>
      </div>

      <!--Input and definition-->
      <div class="col-12">
        <div class="col-5">
          <p>{{'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.NEW_REQUEST_VALIDTY_MESSAGE' | translate}}</p>
        </div>
        <div class="col-7">
          <input [ngClass]="{'notValid': !isRequestOk() }"
                 pInputText type="text" [(ngModel)]="newRequestName">
        </div>
      </div>

    </div>

    <!--Update request-->
    <div *ngIf="!isABrandNewRequest()" class="grid">
      <div class="col-12">
        <h3 class="center">{{'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.UPDATE_REQUEST_DESCRIBTION_MESSAGE' |
          translate}} {{selectedRequestName}}</h3>
      </div>
    </div>


    <!--Info message-->
    <div class="grid">
      <div class="col-12 center">
        <p>{{'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.SAVE_EXPLICATION_MESSAGE' | translate}}</p>
      </div>
    </div>
    <hr>

    <!--Validate button-->
    <div class="grid">
      <div class="col-12 center">
        <button pButton type="button" [icon]="'fa fa-cloud'" class="p-button-success"
                [label]="'SEARCH_COMPONENT.FORM.BUTTON_UPDATE' | translate"
                (click)="saveNewRequest()"
                [disabled]="!isRequestOk()">
        </button>
      </div>
    </div>

  </p-dialog>
</div>
